import { isNonEmptyObject } from '@/utils';
import { GridRowModes, GridRowModesModel, GridRowsProp } from '@mui/x-data-grid';
import { cloneDeep, isFunction } from 'lodash';



function useEditToolBar(props:any) {
    const {
        setRows,
        setRowModesModel,
        newRecord,
        fieldToFocus,
        newRecordId,
        exportFn,
      } = props;
    
      if (!isNonEmptyObject(newRecord) && !isFunction(exportFn)) {
        return undefined;
      }
    
      const handleAddRecordClick = () => {
        const _newRecord = { ...cloneDeep(newRecord), isNew: true };
        setRows((oldRows:GridRowsProp) => [...oldRows, _newRecord]);
        setRowModesModel((oldModel:GridRowModesModel) => ({
          ...oldModel,
          [newRecordId]: { mode: GridRowModes.Edit, fieldToFocus },
        }));
      };
    
      const handleExportClick = () => {
        if (isFunction(exportFn)) exportFn?.();
      };
    
  return { handleAddRecordClick, handleExportClick ,  newRecord, exportFn}
}

export default useEditToolBar